

const GxHorizontalLine = () => {
  return (
    <div className=" sm:block grow h-px bg-gray-300 relative">
      <span className="absolute -left-1 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-gray-300 rounded-full"></span>
      <span className="absolute -right-1 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-gray-300 rounded-full"></span>
    </div>
  );
};

export default GxHorizontalLine;
